import { ApiLambdalerAuthHeaderSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { ClaimNumberSchema, ClaimSeveritySchema } from '../model/index.js';
const UpdateLossSeveritySchemas = {
    params: z.object({
        claimNumber: ClaimNumberSchema,
    }),
    body: z.object({
        severity: ClaimSeveritySchema,
    }),
    headers: ApiLambdalerAuthHeaderSchema.pick({ requestActor: true }).required({
        requestActor: true,
    }),
    response: z.object({
        claimNumber: ClaimNumberSchema,
        lossDetails: z.object({
            severity: ClaimSeveritySchema,
        }),
    }),
};
export const UpdateLossSeverityRequestSchema = UpdateLossSeveritySchemas.params
    .merge(UpdateLossSeveritySchemas.body)
    .merge(UpdateLossSeveritySchemas.headers);
export const UpdateLossSeverityApiSchema = UpdateLossSeveritySchemas;
